import { IPage } from '../../types/pagination';

/** Максимальное количество видимых страниц-цифр для базового случая. */
const MAX_BASE_PAGES_COUNT = 6;

/** Минимальное количество страниц-цифр после многоточия. Вычитаем 1-ю страницу и 1-е многоточие в середине. */
const AFTER_DOTS_MIN_PAGE_COUNT = MAX_BASE_PAGES_COUNT - 2;

const DOTS = '...';

export function getPages(currentPage: number, maxPage: number): IPage[] {
  if (maxPage <= 1) {
    return [];
  }

  const pages: IPage[] = [];

  /* Состояние без многоточий: 1, 2, 3, 4, 5 */
  if (maxPage <= MAX_BASE_PAGES_COUNT) {
    for (let i = 1; i <= maxPage; i++) {
      pages.push({
        value: i,
        text: String(i),
      });
    }

    return pages;
  }

  /* Состояние 1, 2, 3, 4, 5, 6, ... */
  if (currentPage < MAX_BASE_PAGES_COUNT - 1) {
    for (let i = 1; i <= MAX_BASE_PAGES_COUNT; i++) {
      pages.push({
        value: i,
        text: String(i),
      });
    }

    if (maxPage === MAX_BASE_PAGES_COUNT + 1) {
      // Особый случай: если после видимых страниц только одна страница, показываем её вместо многоточия.
      pages.push({
        value: maxPage,
        text: String(maxPage),
      });
    } else {
      pages.push({
        value: MAX_BASE_PAGES_COUNT + 1,
        text: DOTS,
      });
    }

    return pages;
  }

  const firstPageBetweenDots = currentPage - 1;
  const lastPageBetweenDots = firstPageBetweenDots + AFTER_DOTS_MIN_PAGE_COUNT - 1;

  /* Состояние 1...4, 5, 6, 7... */
  if (lastPageBetweenDots <= maxPage - 2) {
    pages.push(
      {
        value: 1,
        text: String(1),
      },
      {
        value: firstPageBetweenDots - 1,
        text: DOTS,
      },
    );

    for (let i = firstPageBetweenDots; i < firstPageBetweenDots + AFTER_DOTS_MIN_PAGE_COUNT; i++) {
      pages.push({
        value: i,
        text: String(i),
      });
    }

    pages.push({
      value: lastPageBetweenDots + 1,
      text: DOTS,
    });

    return pages;
  }

  /* Состояние 1...4, 5, 6, 7, 8 */
  pages.push(
    {
      value: 1,
      text: String(1),
    },
    {
      value: maxPage - AFTER_DOTS_MIN_PAGE_COUNT - 1,
      text: DOTS,
    },
  );

  for (let i = maxPage - AFTER_DOTS_MIN_PAGE_COUNT; i <= maxPage; i++) {
    pages.push({
      value: i,
      text: String(i),
    });
  }

  return pages;
}
